import MapperLayerShell from './MapperLayerShell';

/** Standalone admin /mapper route — same layer shell as embed, inside App layout. */
export default function MapperStandalonePage() {
  return <MapperLayerShell />;
}
